(() => {
  function parse(title) {
    const sizes = {};
    const text = String(title).toUpperCase();
    const units = {CM: /([\d.,\s-]+)\s*CM\b/g, W: /([\d.,\s-]+)\s*US\s*W\b/g, M: /([\d.,\s-]+)\s*US\s*M\b/g, Y: /([\d.,\s-]+)\s*Y\b/g};
    Object.entries(units).forEach(([system, pattern]) => {
      const values = [...text.matchAll(pattern)].flatMap(match => (match[1].replace(/,(?=\s|\d+\.)/g, ' ').replace(/,(?=\d{2}\b)/g, ' ').match(/\d+(?:[.,]\d+)?/g) || []).map(value => Number(value.replace(',', '.'))));
      if (values.length) sizes[system] = [...new Set(values)];
    });
    return sizes;
  }
  function compare(a, b) {
    const left = parse(a), right = parse(b);
    for (const system of ['CM', 'Y', 'W', 'M']) {
      if (left[system]?.length && right[system]?.length) return Math.min(...left[system]) - Math.min(...right[system]);
    }
    const alpha = ['XXXS', 'XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', 'XXXL', '3XL', '4XL', '5XL'];
    const ai = alpha.indexOf(String(a).trim().toUpperCase()), bi = alpha.indexOf(String(b).trim().toUpperCase());
    if (ai >= 0 && bi >= 0) return ai - bi;
    return String(a).localeCompare(String(b), undefined, {numeric: true});
  }
  window.BNSizes = {parse, compare, matches: (title, system, size) => (parse(title)[system] || []).some(value => Math.abs(value - size) < 0.001)};
})();
